module.exports = __webpack_public_path__ + "img/math_lo.17b32861.jpg";